import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { getOrCreateMe, SESSION_QUERY_KEY } from "./useSession";
import type { AnonymousMe } from "@/types";

/**
 * Hook ciblé S6-5 (GAP-2 — modale RGPD) : expose la session courante
 * (`GET /api/v1/sessions/me`) sous forme d'un `UseQueryResult` brut pour
 * que les consumers UI (notamment `ConsentModal` côté layout racine)
 * accèdent à `isLoading` / `data` directement.
 *
 * Partage la même `queryKey` (`SESSION_QUERY_KEY`) et la même fonction
 * `getOrCreateMe` que `useSession()` : invalider la query via
 * `queryClient.invalidateQueries({ queryKey: SESSION_QUERY_KEY })`
 * après `POST /sessions/consent` re-fetch automatiquement les deux hooks.
 */
export function useSessionMe(): UseQueryResult<AnonymousMe, unknown> {
  return useQuery<AnonymousMe, unknown>({
    queryKey: SESSION_QUERY_KEY,
    queryFn: getOrCreateMe,
    staleTime: 5 * 60_000,
    retry: false,
  });
}

export { SESSION_QUERY_KEY };
